export const QboSystemAccounts = Object.freeze({
    UNDEPOSITED_FUNDS: "Undeposited Funds",
    ACCOUNTS_RECEIVABLE: "Accounts Receivable (A/R)",
    ACCOUNTS_PAYABLE: "Accounts Payable (A/P)",
    OPENING_BALANCE_EQUITY: "Opening Balance Equity",
    RETAINED_EARNINGS: "Retained Earnings",
    OWNERS_EQUITY: "Owner’s Equity",
    PARTNERS_EQUITY: "Partner’s Equity",
    MEMBERS_EQUITY: "Member’s Equity",
    SALES_TAX_PAYABLE: "Sales Tax Payable",
    RECONCILIATION_DISCREPANCIES: "Reconciliation Discrepancies",
    UNCATEGORIZED_INCOME: "Uncategorized Income",
    UNCATEGORIZED_EXPENSE: "Uncategorized Expense",
    UNCATEGORIZED_ASSET: "Uncategorized Asset",
    INVENTORY_ASSET: "Inventory Asset",
    PAYROLL_EXPENSES: "Payroll Expenses",
    PAYROLL_LIABILITIES: "Payroll Liabilities",
    EXCHANGE_GAIN_OR_LOSS: "Exchange Gain or Loss",
    OTHER_CURRENT_LIABILITY: "Other Current Liability",
    OTHER_CURRENT_ASSET: "Other Current Asset"
});